import React, { useState } from "react";

import Dialog from "@mui/material/Dialog";
import Divider from "@mui/material/Divider";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuListItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { globalStyles } from "@client/shared/constants";
import { Box } from "@mui/material";
import aboutStyles from "./styles";

const AboutModal = ({ classes: passedClasses = {}, version = {} }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <MenuListItem onClick={() => setIsOpen(true)}>
        <ListItemText primary="About" />
        <ListItemIcon sx={aboutStyles.icon}>
          <InfoOutlinedIcon fontSize="small" />
        </ListItemIcon>
      </MenuListItem>

      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <DialogTitle hasClose sx={aboutStyles.aboutHeading}>
          <Typography variant="h6">Voicemail Broadcast</Typography>
          <IconButton aria-label="close" onClick={() => setIsOpen(false)}>
            <CloseIcon sx={{ color: '#B0B0B0'}} />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={aboutStyles.dialogContent}>
          <Box>
            <Divider />

            <Box sx={aboutStyles.group}>
              <Typography variant="subtitle2">Version:</Typography>
              <Typography variant="subtitle2" sx={aboutStyles.values}>
                {version.release}
              </Typography>
            </Box>
            <Box sx={aboutStyles.group}>
              <Typography variant="subtitle2">Date:</Typography>
              <Typography variant="subtitle2" sx={aboutStyles.values}>
                {version.date}
              </Typography>
            </Box>
            <Divider />
            <Box sx={aboutStyles.group}>
              <Typography variant="subtitle2">Developed by: </Typography>
              <Typography variant="subtitle2" sx={aboutStyles.developedBy}>
                RingCentral Professional Services
              </Typography>
              <img src='/assets/psi-diamond.svg' alt="Psi" style={{ height: "38px" }} />
            </Box>
            <Divider sx={globalStyles.width[100]} />
            <Box sx={aboutStyles.group}>
              <img
                alt="Brand logo"
                src='/assets/brand-logo.svg'
                style={{ height: "26px" }}
              />
              <Typography
                variant="caption"
                color="textSecondary"
                sx={aboutStyles.values}
              >
                Copyright &copy; 1999-2021 RingCentral Inc. All Rights Reserved
              </Typography>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AboutModal;
